import Vue from 'vue'
// import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import FeatherIconWrapper from '@/components/FeatherIconWrapper.vue'

Vue.component('FeatherIcon', FeatherIconWrapper)
// Vue.component(FeatherIcon.name, FeatherIcon)
 